module.exports = __webpack_public_path__ + "img/sun-cloud-rain.fbcaea6.svg";